module.exports = ".noOfrowsStaffManagement {\n  margin-top: -28px;\n  padding-bottom: 10px;\n  width: 73%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/staff-management-summary/staff-management-summary.component.scss
// module id = ./src/app/staff-management-summary/staff-management-summary.component.scss
// module chunks = main